export const tabletBreak = 1180;
export const tableBreak = 860;
export const mobileBreak = 600;
export const large3 = [4, 11, 15]
export const largeItems = [2, 12, 16, 20]

export function isMobile(curWidth, curHeight, isHome){
  if (curWidth < mobileBreak) return true
  return false;
}

export function getDevice(e=false){
    let width;
    let height;
    if (e){
      width = e.target.innerWidth;
      height = e.target.innerHeight;
    } else {
      width = window.innerWidth;
    }
    if(width > tabletBreak){
      return 'desktop'
    } else if(width > tableBreak && width <= tabletBreak ){
        return 'laptop'
    } else if (width > mobileBreak && width <= tableBreak){
        return 'tablet'
    } else if (width <= mobileBreak){
        return 'mobile'
    }
  }

export const sanitiser = (input) => {
  if (input)
    return input.replace(/[.,\/#!?$%\^&\*;:{}=\-_`\s~()]/g,"")
  return ""
}

export const cursorChange = (makeActive, activeType=0) => {
  let stringAppend = "";
  if (activeType==0)
    stringAppend = "-2"
  try{
      let cursor = document.getElementById("cursor-circle")
      if (makeActive){
          cursor.classList.add("cursor-active"+stringAppend)
      } else{
          cursor.classList.remove("cursor-active-2")
          cursor.classList.remove("cursor-active")
      }
  } catch{
      
  }
}

export function minuteRepresentation(seconds){
  let remainderSeconds = (Math.floor(seconds) % 60).toString();
  let minutes = Math.floor(seconds/60).toString();
  if(remainderSeconds.length < 2){
      remainderSeconds = '0' + remainderSeconds
  } else{
      if(minutes !=='0'){
          if(minutes.length < 2){
              minutes = '0' + minutes
          }
      }
  }

  return minutes+":"+remainderSeconds
}  

export function updateTime(setter, curDate){
  let dateEvent = new Date();
  let newDate = dateEvent.toLocaleString('en-GB', {hour: '2-digit', minute: '2-digit',  hour12: false, timeZone: 'Europe/London' });
  if (newDate !==curDate)
    setter(newDate)
}


export function calcCenterMove(element){

  /*
  X and Y are the current position of the element to be moved (top left corner).
  Width and Height are the width and height of the element to be moved.
  CX and CY are the X and Y coordinates of the centre of the screen.
  */

  var x       = element.getBoundingClientRect().x;
  var y       = element.getBoundingClientRect().y;
  var width   = element.getBoundingClientRect().width;
  var height  = element.getBoundingClientRect().height;
  var cx      = window.innerWidth / 2;
  var cy      = window.innerHeight / 2;
  var xVector = cx-(width/2)-x;
  var yVector = cy-(height/2)-y;
  return [xVector, yVector];
}

export function countProjects(projectData, tags){
  let runningCount = {};
  projectData.forEach((item) => {
    let curTags = item.tags;
    curTags.forEach((tag) => {
      tag = tag.toString();
      if(runningCount[tag]){
        runningCount[tag] += 1;
      } else{
        runningCount[tag] = 1;
      }
    });
  });

  let total = 0;
  let refinedCount = {};
  tags.forEach((tag) => {
    const count = runningCount[tag.id] || 0;
    total += count;
    refinedCount[tag.id] = {
      name: tag.tagName,
      count: count
    };
  });
  return [refinedCount, total];
}

export function getGutterWidth(pageWidth){
  if(pageWidth <= 1100){
      if(pageWidth > 850){
          return{
              main: 70,
              aux: 30,

          }
      } else if (pageWidth > 775){
          return{
              main: 50,
              aux: 30
          }
      } else if(pageWidth >= 600){
          return{
              main: 50,
              aux: 15
          }
      } else{
          return{
              main: 20,
              aux: 0
          }
      }
  } return{
      main: 70,
      aux: 30
  }
}

// Helper function to scroll to a target position
export  function smoothScrollTo(element, targetX, targetY, duration, easingFunction) {
  const startX = element.scrollLeft;
  const startY = element.scrollTop;
  const startTime = performance.now();
  
  function easeOutCubicBezier(t, p1x, p1y, p2x, p2y) {
      // Approximation of the cubic-bezier using a standard implementation
      return (
      3 * (1 - t) ** 2 * t * p1y +
      3 * (1 - t) * t ** 2 * p2y +
      t ** 3
      );
  }
    
      const step = (currentTime) => {
          const elapsedTime = currentTime - startTime;
          const progress = Math.min(elapsedTime / duration, 1);
      
          // Apply the easing function
          const easedProgress = easeOutCubicBezier(progress, ...easingFunction);
      
          const currentX = startX + (targetX - startX) * easedProgress;
          const currentY = startY + (targetY - startY) * easedProgress;
      
          element.scrollTo(currentX, currentY);
      
          if (progress < 1) {
          requestAnimationFrame(step);
          }
      };

  requestAnimationFrame(step);
}